/**
 * Bounded polling loop — breaks out after consecutive no-progress steps.
 *
 * `waitForLocalAlbumIndexDepth` (#1270) awaited `loadNextLocalAlbumIndexPage` in a
 * bare `while` loop: a page fetch that fails (e.g. library_busy_scanning while a
 * scan batch is writing) swallows its error and reports "still more pages" without
 * ever advancing the offset, so the loop spun forever and scroll restore never
 * applied — the wall painted at the top and stayed there.
 */
export async function pollWithStallGuard(
  shouldContinue: () => boolean,
  getProgressMarker: () => number,
  step: () => Promise<unknown>,
  maxStalls = 3,
): Promise<void> {
  let stalls = 0;
  let last = getProgressMarker();
  while (shouldContinue()) {
    await step();
    const now = getProgressMarker();
    if (now === last) {
      stalls += 1;
      if (stalls >= maxStalls) return;
    } else {
      stalls = 0;
      last = now;
    }
  }
}
